import React, { useEffect, useState } from 'react';
import { DisableUIOverlayEvent, WarsEvents } from '@playroomkit/pr-wars/events';
import { useManager } from '@src/contexts/WarsContext';
import { ConnectionInfo } from '@playroomkit/pr-wars';
import ScalableWrapper from '@components/ScalableWrapper';
import View from '@components/View';
import { ConnectionQuality } from '@playroomkit/pr-wars-data';
import { ItemImage } from '@components/Shop/ShopComponents';

const qualityOrder = {
  [ConnectionQuality.EXCELLENT]: 0,
  [ConnectionQuality.FAIR]: 1,
  [ConnectionQuality.POOR]: 2,
  [ConnectionQuality.DISCONNECTED]: 3,
  [ConnectionQuality.UNKNOWN]: 4,
};

const ConnectionQualityLabels: Record<ConnectionQuality, string> = {
  [ConnectionQuality.EXCELLENT]: "Great Connection 🟢",
  [ConnectionQuality.FAIR]: "Good Connection 🟡",
  [ConnectionQuality.POOR]: "Limited Connection 🔴",
  [ConnectionQuality.DISCONNECTED]: "Not Connected ⚪",
  [ConnectionQuality.UNKNOWN]: "Status Unavailable ⚫",
};

const PlayerConnectionInfo: React.FC = () => {

  const manager = useManager();
  const [connectionInfos, setConnectionInfos] = useState<ConnectionInfo[]>([]);
  const [showUI, setShowUI] = useState(false);

  useEffect(() => {
    const handleEvent = () => {
      const infos = manager.getPlayerConnectionStatus();
      // sort by quality
      infos.sort(
        (a: any, b: any) =>
          qualityOrder[a.quality as keyof typeof qualityOrder] -
          qualityOrder[b.quality as keyof typeof qualityOrder]
      );
      setConnectionInfos(infos);

      setShowUI(true);
    }

    document.addEventListener(WarsEvents.DisplayPlayerInfoEvent, handleEvent);

    // Cleanup function to remove event listeners
    return () => {
      document.removeEventListener(WarsEvents.DisplayPlayerInfoEvent, handleEvent);
    };
  }, [showUI, connectionInfos]);


  const handleClose = () => {
    setShowUI(false);
    document.dispatchEvent(new DisableUIOverlayEvent());
  }

  return (
    <>
    {showUI && (
      <View className="w-screen h-dvh absolute top-0 left-0 z-[999999]">
        <View enableEventCapturing className='w-full h-full absolute top-0 left-0 bg-black/60' onClick={handleClose} />
         <ScalableWrapper maintainAspectRatioBy="height" anchor="top-right">
          <View className="w-full h-full flex items-end justify-start p-10">
            <View enableEventCapturing className='bg-white max-w-sm w-full p-4 rounded'>
            <div className="text-xl font-bold mb-5 text-center">
              Player Connection Info
            </div>
            <section className="space-y-3">
                {connectionInfos.map((info) => (
                  <div key={info.player.uid} className="flex items-center gap-2">
                    <ItemImage className="size-10 rounded-full object-cover" src={info.player.profileImageUrl ?? undefined} />
                    <label>
                        <span>{info.player.displayName}</span>
                        <span className="font-sans font-medium">
                          {': '}{ConnectionQualityLabels[info.quality as keyof typeof ConnectionQualityLabels]}
                        </span>
                      </label>
                  </div>
                ))}
              </section>
            </View>
          </View>
       </ScalableWrapper>
      </View>
    )}
    </>
  );
};

export default PlayerConnectionInfo;